import { TreeModifier } from "@/components/InterventionTemplate/TreeModifier";
import { DATASET_TYPES } from "@/constants/DatasetTypes";

export const useSectionsFromMenu = (
  source,
  repetitionIndex = null,
  layoutIndex = null,
  observationId = null,
  childrenKey = "children"
  // TODO IMP-1216 fix max-params
  // eslint-disable-next-line max-params
) => {
  let current;
  let parent;
  const { sections, count } = filterSections(source, childrenKey, 0);

  if (layoutIndex) {
    current = TreeModifier.find(sections, childrenKey, (tree) => {
      return repetitionIndex
        ? tree.repetition_index === repetitionIndex
        : tree.layout_index === layoutIndex;
    });

    parent = TreeModifier.find(sections, childrenKey, (tree) => {
      return !tree.repetition_index && tree.layout_index === layoutIndex;
    });
  } else if (repetitionIndex) {
    current = TreeModifier.find(sections, childrenKey, (tree) => {
      return tree.repetition_index === repetitionIndex;
    });

    parent = TreeModifier.find(sections, childrenKey, (tree) => {
      return (
        !tree.repetition_index && tree.layout_index === current?.layout_index
      );
    });
  } else if (observationId) {
    current = TreeModifier.find(sections, childrenKey, (tree) => {
      return tree.observation_id === observationId;
    });

    parent = TreeModifier.find(sections, childrenKey, (tree) => {
      return !tree.repetition_index && tree.layout_index === layoutIndex;
    });
  }

  return { sections, count, current, parent };
};

const filterSections = (source, childrenKey, count) => {
  const sections = source
    ?.filter((section) => !DATASET_TYPES.includes(section.type))
    .map((section) => {
      section["row_index"] = count;
      count++;

      if (section[childrenKey]) {
        const result = filterSections(section[childrenKey], childrenKey, count);
        count = result.count;
        section[childrenKey] = result.sections;
        if (!section[childrenKey]?.length) {
          delete section[childrenKey];
        }
      }

      return section;
    });

  return { sections, count };
};
